import styled from 'styled-components';
import Caption from './Caption';

const Wrapper = styled.div`
  height: 400px;
  position: relative;
  font-weight: 400;
  background-color: white;
  background-size: cover;
  color: white;
  margin-bottom: 3rem;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.2);
  }

  ::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: -moz-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) 1%,
      rgba(0, 0, 0, 0.05) 80%,
      rgba(0, 0, 0, 0.1) 90%,
      rgba(0, 0, 0, 0.2) 100%
    );
    background: -webkit-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) 1%,
      rgba(0, 0, 0, 0.05) 80%,
      rgba(0, 0, 0, 0.1) 90%,
      rgba(0, 0, 0, 0.2) 100%
    );
    background: -o-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) 1%,
      rgba(0, 0, 0, 0.05) 80%,
      rgba(0, 0, 0, 0.1) 90%,
      rgba(0, 0, 0, 0.2) 100%
    );
    background: -ms-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) 1%,
      rgba(0, 0, 0, 0.05) 80%,
      rgba(0, 0, 0, 0.1) 90%,
      rgba(0, 0, 0, 0.2) 100%
    );
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) 1%,
      rgba(0, 0, 0, 0.05) 80%,
      rgba(0, 0, 0, 0.1) 90%,
      rgba(0, 0, 0, 0.2) 100%
    );
  }

  .image-label {
    margin-bottom: 1rem;
    font-size: 50px;
    font-weight: 900;
    line-height: 60px;
    font-style: normal;
    color: #ffffff;
  }

  .wrapper {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  @media (max-width: 767px) {
    padding: 5px;
    height: 240px;

    .image-label {
      font-size: 36px;
      line-height: 45px;
    }

    .wrapper {
      width: 80%;
    }
  }

  @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {
    height: 1024px;

    width: 768px;
  }

  @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
    height: 768px;

    width: 768px;
  }

  @media screen and (device-aspect-ratio: 40/71) {
    height: 530px;

    width: 530px;
  }
`;

const FullWidthImage = ({
  slice,
}: {
  slice: { primary: { image?: any; caption?: any } };
}) => {
  const imageUrl = slice.primary.image.url;
  const { caption } = slice.primary;

  return (
    <Wrapper
      className="blog-header single"
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className="wrapper">
        <Caption caption={caption} />
      </div>
    </Wrapper>
  );
};

export default FullWidthImage;
